module.exports = __webpack_public_path__ + "static/media/SF-4-A.f11fa7bf.mp3";